import GLOBAL from '../configs/config_global';
import { getGlobalState, setGlobalState, STATE_KEYS } from '../configs/config_state';
import { cloneDeep } from 'lodash';
import { storeData } from './util_helpers';
import { toast } from 'react-hot-toast';

import * as RootNavigation from '../navigation/RootNavigation';
import routeKeys from '../navigation/RouteKeys';
import { saveToken } from './util_authentication';

// region Function - Update Location List
export function updateLocationList(index = 0, data, byPassSameLocation = true) {
    const usingData = data || getGlobalState(STATE_KEYS.LOCATION_LIST);

    // Serialize location for easier query later
    const locationObj = {};
    usingData.forEach((location) => (locationObj[location['squareup_location_id']] = location));

    const currentLocationIndex = getGlobalState(STATE_KEYS.CURRENT_LOCATION_INDEX);
    if ((index === currentLocationIndex) && !byPassSameLocation) { return; }

    // Save new data to global state
    setGlobalState(STATE_KEYS.CURRENT_LOCATION_INDEX, index);
    setGlobalState(STATE_KEYS.LOCATION_LIST, usingData);

    // Reload data on all page
    setTimeout(() => {
        GLOBAL.PROFILE?.forceUpdate();
        GLOBAL.DASHBOARD?.forceUpdate();
        GLOBAL.ORDERS?.completedOrdersModal?.resetPage();
        GLOBAL.ORDERS?.mainNavBar?.refreshNavBar();
        GLOBAL.ORDERS?.startFetchingData();
        GLOBAL.MENU?.forceUpdate();
        GLOBAL.CATERING?.forceUpdate();
    }, 500);
}
// endregion

// region Function - Check Account Exists
export function checkAccountExist(email = '', loginType = 'custom') {
    const accountList = getGlobalState(STATE_KEYS.ACCOUNT_LIST);
    return(accountList.find((item) => (
        (item.data.email.toLowerCase() === email.toLowerCase()) &&
        (item.service.toLowerCase() === loginType.toLowerCase()))
    ));
}
// endregion

// region Function - Update Account List
export function updateAccountList(accountList = null, selectedIndex = -1) {
    const usingAccountList = accountList || getGlobalState(STATE_KEYS.ACCOUNT_LIST);

    // Save selected account index to local storage and to global state
    if (selectedIndex > -1) {
        storeData('accountListIndex', JSON.stringify({ index: selectedIndex }));

        setGlobalState(STATE_KEYS.ACCOUNT_LIST, usingAccountList);
        setGlobalState(STATE_KEYS.ACCOUNT_LIST_SELECTED_INDEX, selectedIndex);
    }

    // Set data to state
    setGlobalState(STATE_KEYS.TRUCK_DATA, usingAccountList[selectedIndex].data.trucks[0]);
}
// endregion

// region Function - Refresh Account List
export function refreshMainAccountList(accountID = -1, newTruckData = {}) {
    const accountList = getGlobalState(STATE_KEYS.ACCOUNT_LIST);
    const accountIndex = accountList.findIndex((account) => account.data.id === accountID);

    const tempArr = cloneDeep(accountList);

    if (accountIndex > -1) {
        tempArr[accountIndex].data.trucks[0] = Object.assign(cloneDeep(tempArr[accountIndex].data.trucks[0]), newTruckData);

        // Save data to local storage
        saveToken(GLOBAL.DATA.USER_TOKEN, GLOBAL.DATA.LOGIN_SERVICE, tempArr[accountIndex].data);
    }

    // Set data to main state
    setGlobalState(STATE_KEYS.ACCOUNT_LIST, tempArr);
    setGlobalState(STATE_KEYS.TRUCK_DATA, Object.assign(cloneDeep(getGlobalState(STATE_KEYS.TRUCK_DATA)), newTruckData));
}
// endregion

// region Function - Go Switch Account
export function goSwitchAccount(switchingAccount = {}, accountIndex = 0, skipGlobalDataRegister = false) {
    /*
         Note: getUserData() has already been called before this function
    */

    // Reset global scene data before switching
    GLOBAL.PROFILE = null;
    GLOBAL.DASHBOARD = null;
    GLOBAL.ORDERS = null;
    GLOBAL.CATERING = null;
    GLOBAL.MORE = null;

    if (!skipGlobalDataRegister) {
        // Save selected account index to local storage
        storeData('accountListIndex', JSON.stringify({ index: accountIndex }));

        // Save vendor data to global state
        GLOBAL.DATA.USER_TOKEN = switchingAccount.token;
        GLOBAL.DATA.LOGIN_SERVICE = switchingAccount.service;
        GLOBAL.DATA.USER = switchingAccount.data;

        // Update data to main state
        updateLocationList(0, switchingAccount.data.locations);
        updateAccountList(null, accountIndex);
    }

    // Move to scene home
    RootNavigation.reset(routeKeys.MAIN);

    // Inform the user
    toast('Welcome back to Truckster Vendor, ' + switchingAccount.data.name);
}
// endregion

// region Function - Get Default Location List
export function getDefaultSquareLocation() {
    const locationList = getGlobalState(STATE_KEYS.LOCATION_LIST);
    if (locationList.length > 0) {
        const defaultIndex = locationList.findIndex((item) => item['is_default'] === 1);
        const foundIndex = defaultIndex > -1 ? defaultIndex : 0;
        return(Object.assign(cloneDeep(locationList[foundIndex]), { itemIndex: foundIndex }));
    }
    else return({ itemIndex: -1 });
}
// endregion

// region Function - Get Current Square Location ID
export function getCurrentSquareLocationID() {
    const locationList = getGlobalState(STATE_KEYS.LOCATION_LIST);
    const locationIndex = getGlobalState(STATE_KEYS.CURRENT_LOCATION_INDEX);
    return(locationList.length > 0 ? locationList[locationIndex].squareup_location_id : null)
}
// endregion

// region Function - Get Current Square Location
export function getCurrentSquareLocation() {
    const locationList = getGlobalState(STATE_KEYS.LOCATION_LIST);
    const locationIndex = getGlobalState(STATE_KEYS.CURRENT_LOCATION_INDEX);
    return(locationList.length > 0 ? locationList[locationIndex] : null)
}
// endregion
